'use client'

import { AppBar, Box, Stack, useTheme } from '@mui/material'
import classNames from 'classnames'
import { useCallback, useState } from 'react'
import { usePathname } from 'next/navigation'
import Link from '@biolumina/ui/components/link/link'
import { useGlobalState } from '@biolumina/ui/context/globalStateProvider'
import { StyledNavMenu } from './navMenu.styles'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'

export default function NavMenu({ data, direction = 'row' }) {
  const [anchor, setAnchor] = useState(null)
  const open = Boolean(anchor)
  const { scrollSpyIndex, scrollMargin } = useGlobalState()

  const pathname = usePathname()
  const isCurrent =
    pathname.replaceAll('/', '') === data.href.replaceAll('/', '')

  const onMouseEnter = useCallback((e) => {
    setAnchor(e.currentTarget)
  }, [])

  const onMouseLeave = useCallback(() => {
    setAnchor(null)
  }, [])

  const menuH = '60px'
  const {
    display: navDisplay,
    menuAlign = 'left',
    className,
    icon,
    ...navData
  } = data

  const LinkComponent = navData.component || Link
  return (
    <StyledNavMenu onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
      <LinkComponent
        className={classNames('nav-link', className, {
          hover: open,
          active: isCurrent,
          hasChildren: navData.children && navData.children.length,
        })}
        data-tracking="header-nav-item"
        variant="nav"
        component="p"
        {...navData}
      >
        {navDisplay}
        {navData.children &&
          (open || isCurrent ? <ExpandLessIcon /> : <ExpandMoreIcon />)}
      </LinkComponent>

      {navData.children && (
        <AppBar
          className={classNames('sub-nav-container', { persist: isCurrent })}
          sx={{
            display: navData.children && open ? 'block' : 'none',
            boxShadow: 'none',
            height: menuH,
            top: 141,
          }}
        >
          <Stack
            className={classNames('sub-nav')}
            direction={direction}
            spacing={3}
          >
            {navData.children.map(
              ({ display, href, className, ...navItem }, index) => {
                return (
                  <Link
                    key={href}
                    data-tracking="header-nav-item"
                    {...navItem}
                    className={classNames('sub-nav-link', className, {
                      active: isCurrent && scrollSpyIndex === index,
                    })}
                    href={href}
                    data-to-scrollspy-id={href.substring(1)}
                    variant="subNav"
                  >
                    {display}
                  </Link>
                )
              }
            )}
          </Stack>
        </AppBar>
      )}
    </StyledNavMenu>
  )
}
